import { Field, FormSpy } from 'react-final-form';

import { Text } from '@change/ds-core-ui/next';
import { TextField } from '@change/ds-forms/next';

import { useI18n } from '@change-corgi/core/react/i18n';

import { requiredValidatorWithNoMessage } from 'src/app/shared/form/validators';

import { MAX_TITLE_LENGTH } from '../../../../constants';
import type { PetitionUpdateFormValues, TitleInputProps } from '../../types';

import { useTitleInput } from './hooks/useTitleInput';

export function TitleInput({ initialValue }: TitleInputProps) {
	const {
		actions: { handleFormChange, trackFocus },
	} = useTitleInput({ initialValue });
	const { translate } = useI18n();

	return (
		<div className="flex w-full flex-col gap-4">
			<Text variant="heading" size="x-small">
				Post title
			</Text>
			<Field<PetitionUpdateFormValues['title']>
				name="title"
				type="text"
				validate={requiredValidatorWithNoMessage}
				initialValue={initialValue}
			>
				{({ type, ...props }) => (
					<TextField
						data-qa="petition-update-title-input"
						{...props.input}
						type="text"
						id="petition-update-title"
						onFocus={() => {
							trackFocus();
						}}
						data-testid={props.input.name}
						label={translate('corgi.starter_dashboard_v2.post_an_update.form.title_label')}
						labelIsVisible={false} // Hide label as it does not match current design
						placeholder={translate('corgi.starter_dashboard_v2.post_an_update.form.title_placeholder')}
						maxLength={MAX_TITLE_LENGTH}
						supportingText={`${MAX_TITLE_LENGTH} characters`}
					/>
				)}
			</Field>
			<FormSpy data-qa="petition-update-form-spy" subscription={{ values: true }} onChange={handleFormChange} />
		</div>
	);
}
